/** The active entry marked as priority, else the first active one, else undefined. */
const pickActiveContact = (list) => {
  const active = list?.filter(({ active }) => active) ?? [];

  return active.find(({ priority }) => priority) ?? active[0];
};

export default pickActiveContact;
